import React, { Component } from "react";
import { Modal } from "react-bootstrap";
// import DateBlock from "../../../neetjee_guru/components/home/DateBlock";
import { Form, Row, Button, Col, Spinner } from "react-bootstrap";
import moment from "moment";
import "./_timeTableCreationModal.scss";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { components } from 'react-select'
import MultiSelect from "react-multi-select-component";
import { withApollo } from "react-apollo";
import '../_lecturerModal.scss';
import SelectDropdown from '../SelectDropdown';
import CheckboxDropdown from '../../ui/CheckboxDropdown';
import { defaultBranchValue } from "../../../../utils/branchScope";
import { canEdit } from "../../../../utils/modulePermissions";

// /lecturer-timeTable → "Lecturer_timetable". Only reachable through the gated "TimeTable
// Creation" opener in LecturerTimeTableHome, which already raises the Access Denied modal.
// Silent is_edit backstop so the save can't fire even if the modal is opened another way.
const LECTURER_TIMETABLE_MODULE = ["Lecturer_timetable"];

const ADD_LECTURER_PERIODS = gql`
mutation($params:AddLecturePeriods) {
    addLecturePeriods(params: $params)
}
`;


const FETCH_PERIODTIMINGS = gql`
 query($institute_id:Int,$branch_id:Int,$exam_id:Int){
  getClassPeriodsTimings(institute_id:$institute_id,branch_id:$branch_id,exam_id:$exam_id){
      period_id
      period_name
      period_time
    }
 }
 `;

// ── Expense-style filter services (branches with sections + class list) ───────
const GET_BRANCHES = gql`
    query getBranches($institution_id: Int!) {
        getBranches(institution_id: $institution_id) {
            id
            branch_name
            sections {
                id
                class_id
                section_name
            }
        }
    }
`;

const GET_EXAM_CLASSES = gql`
    query($id: Int) {
        getExamClasses(id: $id) {
            id
            class
        }
    }
`;

const GET_ACADEMIC_YEARS = gql`
    query getAcademicYears($id: Int) {
        getAcademicYears(id: $id) {
            id
            academic_year
        }
    }
`;

const GET_CLASS_SUBJECTS = gql`
    query getClassSubjectsByAcademicYear($institute_id: Int!, $classIds: String, $academic_year_id: Int!) {
        getClassSubjectsByAcademicYear(institute_id: $institute_id, classIds: $classIds, academic_year_id: $academic_year_id) {
            id
            class_id
            subject_ids
            subject_names
            checked
        }
    }
`;




class TimeTableCreationModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date().toISOString().slice(0, 10),
            Update: [],
            Branch: defaultBranchValue(""),
            branchError: "",
            Exam: "",
            examError: "",
            Section: "",
            sectionError: "",
            Class: "",
            classError: "",
            startdate: "",
            startTime: new Date(),
            lecturerPeriods: "",
            loader: 0,
            dateTimings: "",
            submitError: "",
            dataClear: 0,
            submitted: false,
            subjectValue: [],
            periodsList: [],
            multiSelectPeriodsList: [],
            periods: "",
            currentDate: new Date().toISOString().slice(0, 10),
            dataClear: 1,
            getEmployees: [],
            examName: "",
            getExams: [],
            getClasses: [],
            getSections: [],
            existingData: [],
            existingSelection: "",
            branches: [],      // raw getBranches result (with sections)
            allClasses: []     // raw getExamClasses result

        };
    }

    componentDidMount() {
        this.fetchBranches();
        this.fetchClasses();
    }

    // Branches (with sections) — same service the Expense module uses.
    fetchBranches = async () => {
        try {
            const institution_id = parseInt(Cookies.get("institutionid"));
            const res = await this.props.client.query({
                query: GET_BRANCHES,
                variables: { institution_id },
                fetchPolicy: "network-only",
            });
            let branches = res.data.getBranches || [];
            if (Cookies.get("userlevel") != "1" && Cookies.get("userlevel") != "2") {
                branches = branches.filter((b) => String(b.id) === String(Cookies.get("branch_id")));
            }
            this.setState({ branches });
        } catch (e) {
            console.error("getBranches failed", e);
        }
    };

    // Institution class list — same service the Expense / Document modules use.
    fetchClasses = async () => {
        try {
            const res = await this.props.client.query({
                query: GET_EXAM_CLASSES,
                variables: { id: 1 },
                fetchPolicy: "network-only",
            });
            this.setState({ allClasses: res.data.getExamClasses || [] });
        } catch (e) {
            console.error("getExamClasses failed", e);
        }
    };



    handleMultipleSelectInputChange = async (e, name) => {
        let seletedClasses = e
        console.log("eeee", e);
        // const delay = (ms) => new Promise((r) => setTimeout(r, ms));
        // await delay(200);
        if (name == "Periods") {
            let qbsearchtopic = Array();
            let qbsearchtopicvalue = Array();
            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const qbtopicval = e[i];
                    console.log("qbtopicval", qbtopicval)
                    const newObj = {
                        label: qbtopicval.label,
                        value: qbtopicval.value
                    }
                    qbsearchtopicvalue.push(newObj);
                    qbsearchtopic.push(qbtopicval.value);
                }
                this.setState({
                    subjectValue: qbsearchtopicvalue,
                    qbsearchsubject: qbsearchtopic,
                });
            }
        }
        let periodsArray = [];
        if (e.length > 0) {
            this.state.Update.map((item) => {

                let selectedOrUnselectedItems = e.filter((item1) => item1.value == item.id);
                console.log("inside", selectedOrUnselectedItems);

                if (selectedOrUnselectedItems.length > 0) {
                    periodsArray.push({ ...item, enabled: false, class_day_type_id: "2", periodTopic: "", sub_class_day_type_id: "2" })
                } else {
                    periodsArray.push({ ...item, enabled: true, class_day_type_id: "3", periodTopic: "", sub_class_day_type_id: "1" })
                }
            })
        } else {
            this.state.Update.map((item) => {
                periodsArray.push({ ...item, enabled: true, class_day_type_id: "3", periodTopic: "" })
            })
        }
        this.setState({ Update: periodsArray });
    }



    //  First Row 
    // ================
    handleInputChange = (e, i) => {
        const name = e.target.name;
        const value = e.target.value;
        console.log("nammamm", name, value);

        let getArray = [];

        if (name == "Branch") {

            if (value != "0") {
                // Branch → populate Classes from getExamClasses, scoped to the branch's sections.
                const selectedBranch = this.state.branches.find((b) => String(b.id) === String(value));
                const branchSections = selectedBranch ? (selectedBranch.sections || []) : [];
                const classIdsInBranch = [...new Set(branchSections.map((s) => Number(s.class_id)))];
                this.state.allClasses.forEach((c) => {
                    if (classIdsInBranch.includes(Number(c.id))) getArray.push({ value: c.id, label: c.class });
                });

                this.setState({
                    Branch: value, branchError: "", Exam: "", Section: "", Class: "", dateTimings: "", Update: [], getEmployees: [], periodsList: [], multiSelectPeriodsList: [], getExams: [], getClasses: getArray, getSections: [], classError: "", examError: "", sectionError: "", existingData: []
                })

            } else {
                this.setState({
                    Branch: "", branchError: "", Exam: "", Section: "", Class: "", dateTimings: "", Update: [], getEmployees: [], periodsList: [], multiSelectPeriodsList: [], getExams: [], getClasses: [], getSections: [], classError: "", examError: "", sectionError: "", existingData: []
                })
            }
        }
        if (name == "Class") {
            if (value != "0") {
                // Class → populate Sections from the branch's getBranches sections (filtered by class).
                const selectedBranch = this.state.branches.find((b) => String(b.id) === String(this.state.Branch));
                const branchSections = selectedBranch ? (selectedBranch.sections || []) : [];
                const seen = new Set();
                branchSections
                    .filter((s) => Number(s.class_id) === Number(value))
                    .forEach((s) => {
                        if (seen.has(s.id)) return;
                        seen.add(s.id);
                        getArray.push({ value: s.id, label: s.section_name });
                    });

                this.setState({
                    branchError: "", Section: "", Class: value, dateTimings: "", Update: [], getEmployees: [], periodsList: [], multiSelectPeriodsList: [], getSections: getArray,
                    classError: "", examError: "", sectionError: "", existingData: []
                })

            } else {

                this.setState({
                    branchError: "", Section: "", Class: "", dateTimings: "", Update: [], getEmployees: [], periodsList: [], multiSelectPeriodsList: [], getSections: [],
                    classError: "", examError: "", sectionError: "", existingData: []
                })

            }
        }
        if (name == "Section") {
            if (value != "0") {
                // Derive exam_id from the branch + class + section combo, then load periods + existing data.
                const match = this.props.globals.b_e_c_s_data.find((item) => item.branch_id == this.state.Branch && item.class_id == this.state.Class && item.section_id == value);
                const derivedExam = match ? match.exam_id : "";
                this.setState({ Update: [], Section: value, Exam: derivedExam, sectionError: "", dateTimings: "" }, () => {
                    this.getEmployess();
                    this.getExistingTimeTable(value);
                });
            } else {
                this.setState({ Update: [], Section: "", Exam: "", sectionError: "", dateTimings: "" });
            }
        }

        if (name == "dateTimings") {
            let periodsArray = [];


            console.log("hello", e.target.value, this.state.existingSelection);

            if (e.target.value == this.state.existingSelection) {

                this.state.existingData.map((item) => {

                    let sub_class_day_type_id = e.target.value;

                    if (e.target.value == "3") {
                        sub_class_day_type_id = "1"
                    }
                    periodsArray.push({ ...item, class_day_type_id: e.target.value, sub_class_day_type_id })
                });
            } else {

                if (e.target.value == 4 || e.target.value == 2) {
                    periodsArray.push({ id: "", periodDate: this.state.date, periodTime: "", periodSubjectId: "", periodSubjectIds: [], period_name: "", periodLecturerId: "", periodLecturerIds: [], periodTopic: "", subjectError: "", LecturerError: "", topicError: "", enabled: true, class_day_type_id: e.target.value, sub_class_day_type_id: e.target.value, existingData: [] })
                } else {
                    this.state.periodsList.map((item, index) => (
                        periodsArray.push({ id: item.period_id, periodDate: this.state.date, periodTime: item.period_time, periodSubjectId: "", periodSubjectIds: [], period_name: item.period_name, periodLecturerId: "", periodLecturerIds: [], periodTopic: "", subjectError: "", LecturerError: "", topicError: "", enabled: true, class_day_type_id: "", sub_class_day_type_id: "", existingData: [] })
                    ))
                }
            }

            this.setState({
                dateTimings: e.target.value, dateTimeError: "", Update: periodsArray
            });
        }

        if (name == "examName" || name == "holidayName") {

            let array = [];
            this.state.Update.map((item) => {
                array.push({ ...item, periodTopic: value })
            })
            this.setState({ Update: array, nameError: "" })
        }
    }

    selDate = (e) => {
        this.setState({ date: e.target.value, Branch: "", Exam: "", Section: "", Class: "", dateTimings: "", Update: [], getEmployees: [], periodsList: [] })
    }

    // ARRAY OF OBJECT 2ND ROW COLUMN
    // =================================


    handleMultiChange = (name, selectedValues, i) => {
        let array = [];
        this.state.Update.forEach((item, index) => {
            if (i === index) {
                let periodSubjectId = item.periodSubjectId;
                let periodSubjectIds = item.periodSubjectIds || [];
                let periodLecturerId = item.periodLecturerId;
                let periodLecturerIds = item.periodLecturerIds || [];

                if (name === "Subject") {
                    periodSubjectIds = selectedValues;
                    periodSubjectId = selectedValues.length > 0 ? selectedValues[0] : "";

                    // Filter lecturer selection to keep only lecturers who teach ANY of the newly selected subjects
                    const availableTeacherIds = (this.state.getEmployees || []).filter((emp) => {
                        if (!emp.subject_ids) return false;
                        const empSubIds = String(emp.subject_ids).split(",").map(id => id.trim());
                        return empSubIds.some(subId => selectedValues.includes(String(subId)));
                    }).map(e => String(e.employee_id));

                    periodLecturerIds = periodLecturerIds.filter(id => availableTeacherIds.includes(String(id)));
                    periodLecturerId = periodLecturerIds.length > 0 ? periodLecturerIds[0] : "";

                } else if (name === "Lecturer") {
                    periodLecturerIds = selectedValues;
                    periodLecturerId = selectedValues.length > 0 ? selectedValues[0] : "";
                }

                array.push({
                    ...item,
                    periodSubjectId,
                    periodSubjectIds,
                    periodLecturerId,
                    periodLecturerIds,
                    subjectError: "",
                    LecturerError: "",
                });
            } else {
                array.push({ ...item });
            }
        });
        this.setState({ Update: array });
    };

    handleChange = (a, i) => {
        let name = a.target.name;
        let value = a.target.value;

        let array = [];
        this.state.Update.forEach((item, index) => {
            if (i == index) {
                let periodSubjectId = item.periodSubjectId;
                let periodSubjectIds = item.periodSubjectIds || [];
                let periodLecturerId = item.periodLecturerId;
                let periodLecturerIds = item.periodLecturerIds || [];
                let periodTopic = item.periodTopic;
                let periodTime = item.periodTime;

                if (name == "Subject") {
                    periodSubjectId = value;
                    periodSubjectIds = value ? [value] : [];
                    periodLecturerId = "";
                    periodLecturerIds = [];
                } else if (name == "Lecturer") {
                    periodLecturerId = value;
                    periodLecturerIds = value ? [value] : [];
                } else if (name == "periodTime") {
                    periodTime = value;
                } else {
                    periodTopic = value;
                }

                array.push({ ...item, periodTopic, periodTime, periodLecturerId, periodLecturerIds, periodSubjectId, periodSubjectIds });
            } else {
                array.push({ ...item });
            }
        });
        this.setState({ Update: array });
    };

    handleMultiChange = (name, selectedValues, i) => {
        let array = [];
        this.state.Update.forEach((item, index) => {
            if (i == index) {
                let periodSubjectIds = item.periodSubjectIds || [];
                let periodSubjectId = item.periodSubjectId || "";
                let periodLecturerIds = item.periodLecturerIds || [];
                let periodLecturerId = item.periodLecturerId || "";

                if (name == "Subject") {
                    periodSubjectIds = selectedValues || [];
                    periodSubjectId = periodSubjectIds[0] || "";
                    periodLecturerIds = [];
                    periodLecturerId = "";
                } else if (name == "Lecturer") {
                    periodLecturerIds = selectedValues || [];
                    periodLecturerId = periodLecturerIds[0] || "";
                }

                array.push({
                    ...item,
                    periodSubjectIds,
                    periodSubjectId,
                    periodLecturerIds,
                    periodLecturerId
                });
            } else {
                array.push({ ...item });
            }
        });
        this.setState({ Update: array });
    };

    handleSubmit = (e) => {
        e.preventDefault();

        // Silent is_edit backstop — the opener already gated entry with its own modal.
        if (!canEdit(LECTURER_TIMETABLE_MODULE)) return;

        if (this.state.dateTimings == "2" || this.state.dateTimings == "4") {
            if (this.state.Update[0].periodTopic == "") {
                this.setState({ nameError: "Enter Valid Name" });
                return "";
            }
        }

        let array = [];
        if (this.state.Update.length > 0) {
            this.state.Update.forEach((item) => {
                let class_topic = item.periodTopic;

                // Support both multi-select arrays and single-select fallbacks
                const subIds = (item.periodSubjectIds && item.periodSubjectIds.length > 0)
                    ? item.periodSubjectIds
                    : (item.periodSubjectId ? [item.periodSubjectId] : [null]);

                const empIds = (item.periodLecturerIds && item.periodLecturerIds.length > 0)
                    ? item.periodLecturerIds
                    : (item.periodLecturerId ? [item.periodLecturerId] : [null]);

                // Multi-row expansion: For each selected subject & teacher, generate a valid GraphQL integer entry
                subIds.forEach((subId, idx) => {
                    const empId = empIds[idx] || empIds[0] || null;
                    array.push({
                        class_period_id: parseInt(item.id),
                        subject_id: subId ? parseInt(subId) : null,
                        employee_id: empId ? parseInt(empId) : null,
                        class_topic: (class_topic || "").toString(),
                        class_date: moment(this.state.date, 'YYYY-MM-DD').unix().toString(),
                        class_day_type_id: parseInt(this.state.dateTimings),
                        sub_class_day_type_id: parseInt(item.sub_class_day_type_id)
                    });
                });
            });
        }
        let params = {
            class_id: parseInt(this.state.Class),
            exam_id: parseInt(this.state.Exam),
            branch_id: parseInt(this.state.Branch),
            institute_id: parseInt(Cookies.get("institutionid")),
            section_id: parseInt(this.state.Section),
            period_timings: array,
        };
        console.log("params", params, this.state.Update);



        this.addLecturerPeriods1(
            params
        ).catch(error => {
            console.log("catch if error");
            console.log(error);
            this.setState({
                periodError: error.graphQLErrors.map(x => x.message), loader: 0
            });
            console.error("ERR =>", error.graphQLErrors.map(x => x.message));
        });

        this.setState({
            loader: 1
        });

    }

    addLecturerPeriods1 = async (
        params) => {
        await this.props.addLecturerPeriods({
            variables: {
                params,
            },
            update: (store, { data }) => {
                console.log("data.finishTest", data);
                if (data.addLecturePeriods) {

                    this.setState({
                        loader: 0,
                        submitted: true
                    })
                    setTimeout(() => {
                        this.props.onHide();
                        window.location.reload(false);
                    }, 1500);
                }
            }

        });
    };

    // Delete HandleSubmit
    // ====================
    deleteHandle = (id) => {
        let deleterows = this.state.Update.filter((item, index) => item.id != id)
        console.log("hhh", deleterows, id);
        this.setState({
            Update: deleterows,
        })
    }

    // Button Click Enter Some , Click Wrong Button Again Ask Starting
    // ===============================================================
    componentDidUpdate() {
        if (this.props.show == true && this.state.dataClear == 0) {
            this.setState({
                date: new Date().toISOString().slice(0, 10),
                Update: [],
                Branch: defaultBranchValue(""),
                branchError: "",
                Exam: "",
                examError: "",
                Section: "",
                sectionError: "",
                Class: "",
                classError: "",
                startdate: "",
                startTime: new Date(),
                lecturerPeriods: "",
                loader: 0,
                dateTimings: "",
                submitError: "",
                dataClear: 1,
                submitted: false,
                subjectValue: [],
                periodsList: [],
                multiSelectPeriodsList: [],
                periods: "",
                currentDate: new Date().toISOString().slice(0, 10),
                dataClear: 1,
                getEmployees: [],
                examName: "",
                getExams: [],
                getClasses: [],
                getSections: [],
                existingData: []

            })
        }
        if (this.props.show == false && this.state.dataClear == 1) {
            this.setState({
                dataClear: 0
            })
        }
    }


    getEmployess = async () => {
        const instituteId = parseInt(Cookies.get("institutionid"));
        const branchId = parseInt(this.state.Branch);

        const result = await this.props.client.query({
            query: gql`
            query($institute_id:Int,$branch_id:Int,){
                getEmployees(institute_id:$institute_id,branch_id:$branch_id){
                  employee_id
                  employee_name
                  subject_ids
                }
              }
            `,
            variables: {
                institute_id: instituteId,
                branch_id: branchId
            },
            fetchPolicy: 'network-only'
        })

        if (result.data.getEmployees.length > 0) {
            this.setState({ getEmployees: result.data.getEmployees })

        } else {
            this.setState({ getEmployees: [] })
        }

        // 1. Fetch active academic years
        let resolvedAyId = null;
        try {
            const ayRes = await this.props.client.query({
                query: GET_ACADEMIC_YEARS,
                variables: { id: 1 },
                fetchPolicy: 'network-only'
            });
            const years = ayRes.data?.getAcademicYears || [];
            // Sort academic years descending by starting year to resolve the latest one by default
            const sortedYears = [...years].sort((a, b) => {
                const yearA = parseInt(String(a.academic_year).split("-")[0]) || 0;
                const yearB = parseInt(String(b.academic_year).split("-")[0]) || 0;
                return yearB - yearA;
            });
            const latestAy = sortedYears[0];
            resolvedAyId = latestAy ? latestAy.id : null;
        } catch (e) {
            console.error("getAcademicYears query failed", e);
        }

        // 2. Fetch class mapped subjects mapped directly to curriculum
        let classSubjects = [];
        if (resolvedAyId && this.state.Class) {
            try {
                const subRes = await this.props.client.query({
                    query: GET_CLASS_SUBJECTS,
                    variables: {
                        institute_id: instituteId,
                        classIds: String(this.state.Class),
                        academic_year_id: parseInt(resolvedAyId)
                    },
                    fetchPolicy: 'network-only'
                });
                const maps = subRes.data?.getClassSubjectsByAcademicYear || [];
                if (maps.length > 0) {
                    const subjectIds = maps[0].subject_ids.split(",").map(id => parseInt(id.trim())).filter(Boolean);
                    const subjectNames = maps[0].subject_names.split(",").map(name => name.trim()).filter(Boolean);
                    const checkedArray = maps[0].checked.split(",").map(chk => chk.trim() === "true");

                    subjectIds.forEach((sid, idx) => {
                        if (checkedArray[idx]) {
                            classSubjects.push({ id: sid, subject: subjectNames[idx] });
                        }
                    });
                }
            } catch (e) {
                console.error("getClassSubjectsByAcademicYear failed", e);
            }
        }
        this.setState({ classMappedSubjects: classSubjects });

        const periods = await this.props.client.query({
            query: gql`
            query($institute_id:Int,$branch_id:Int,$exam_id:Int){
                getClassPeriodsTimings(institute_id:$institute_id,branch_id:$branch_id,exam_id:$exam_id){
                    period_id
                    period_name
                    period_time
                  }
               }
            `,
            variables: {
                institute_id: instituteId,
                branch_id: branchId,
                exam_id: parseInt(this.state.Exam)
            },
            fetchPolicy: 'network-only'
        })

        if (periods.data.getClassPeriodsTimings.length > 0) {

            let multiSelectPeriodsList = [];

            periods.data.getClassPeriodsTimings.map((item) => {
                multiSelectPeriodsList.push({ value: item.period_id, label: item.period_name })
            })

            this.setState({ periodsList: periods.data.getClassPeriodsTimings, multiSelectPeriodsList })

        } else {
            this.setState({ periodsList: [], multiSelectPeriodsList: [] })
        }
    };

    getExistingTimeTable = async (val) => {
        const result = await this.props.client.query({
            query: gql`
            query($institute_id:Int,$branch_id:Int,$exam_id:Int,$section_id:Int,$class_start_date:String,$class_id:Int){
                getClassTimeTable(institute_id:$institute_id,branch_id:$branch_id,exam_id:$exam_id,section_id:$section_id,class_start_date:$class_start_date,class_id:$class_id){
                    class_day_type_id
                    class_period_id
                    period_name
                    subject_id
                    subject_name
                    employee_id
                    employee_name
                    class_topic
                    sub_class_day_type_id
                }
              }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(this.state.Branch),
                class_id: parseInt(this.state.Class),
                section_id: parseInt(val),
                exam_id: parseInt(this.state.Exam),
                class_start_date: moment(this.state.date, 'YYYY-MM-DD').unix().toString()
            },
            fetchPolicy: 'network-only'
        })

        if (result.data.getClassTimeTable.length > 0) {
            let data = result.data.getClassTimeTable;
            let periodMap = {};
            let selectedPeriodList = [];
            let examName = "";

            data.forEach((item) => {
                let enabled = true;
                if (item.class_day_type_id == "3" && item.sub_class_day_type_id == "2") {
                    enabled = false;
                    examName = item.class_topic;
                    selectedPeriodList.push({ label: item.period_name, value: item.class_period_id });
                }

                const pid = item.class_period_id;
                if (!periodMap[pid]) {
                    periodMap[pid] = {
                        class_day_type_id: item.class_day_type_id,
                        sub_class_day_type_id: item.sub_class_day_type_id,
                        enabled: enabled,
                        id: pid,
                        period_name: item.period_name,
                        periodTopic: item.class_topic || "",
                        periodSubjectId: item.subject_id ? String(item.subject_id) : "",
                        periodLecturerId: item.employee_id ? String(item.employee_id) : "",
                        periodSubjectIds: item.subject_id ? [String(item.subject_id)] : [],
                        periodLecturerIds: item.employee_id ? [String(item.employee_id)] : [],
                        subjectError: "",
                        LecturerError: "",
                        topicError: ""
                    };
                } else {
                    if (item.subject_id && !periodMap[pid].periodSubjectIds.includes(String(item.subject_id))) {
                        periodMap[pid].periodSubjectIds.push(String(item.subject_id));
                    }
                    if (item.employee_id && !periodMap[pid].periodLecturerIds.includes(String(item.employee_id))) {
                        periodMap[pid].periodLecturerIds.push(String(item.employee_id));
                    }
                }
            });

            const array = Object.values(periodMap);
            this.setState({ dateTimings: data[0].class_day_type_id, Update: array, subjectValue: selectedPeriodList, examName, existingData: array, existingSelection: data[0].class_day_type_id });
        }

    };

    render() {

        console.log("state", this.state);

        const { dateTimings } = this.state;
        let periodsSelectAll = true;
        let periodslabelledby = "Select";
        let periodsdisablesearch = false;
        if (this.state.periodsList.length > 0) {
            periodsSelectAll = true;
            periodsdisablesearch = false;
        }
        else {
            periodsdisablesearch = true;
            periodsSelectAll = false;
            periodslabelledby = "Periods"
        }


        return (
            <Form>
                <div className="container-fluid  POPUP_PAGE">
                    <Modal
                        {...this.props}
                        size="lg"
                        dialogClassName="ltt-modal"
                        aria-labelledby="contained-modal-title-venter"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title id="example-modal-sizes-title-lg"><i className="fas fa-table" /> Lecturer TimeTable</Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="p-4" style={{ maxHeight: "600px", overflowX: "auto" }}
                        >
                            <div className="">
                                <div className="d-flex justify-content-end">
                                    <Row>
                                        <div className="filter-block d-flex align-items-center mr-4">
                                            <input type="date" className="date form-control" value={this.state.date} onChange={this.selDate} />
                                        </div>
                                    </Row>
                                    {/* </div> */}
                                </div>
                            </div>
                            <Row>
                                <Col xl={12} lg={12} md={12} sm={12} className="mt-3">
                                    <Form>
                                        <Form.Row>
                                            <Form.Group as={Col} lg={4} md={12} sm={12} controlId="SelectBranch">
                                                <Form.Label className="ltt-field-label">Branch</Form.Label>
                                                <SelectDropdown
                                                    options={this.state.branches.map(b => ({ value: b.id, label: b.branch_name }))}
                                                    value={this.state.Branch}
                                                    placeholder="Select Branch"
                                                    onSelect={(val) => this.handleInputChange({ target: { name: "Branch", value: String(val) } })}
                                                />
                                                <Form.Text className="form-text text-danger" type="invalid">
                                                    {this.state.branchError}
                                                </Form.Text>
                                            </Form.Group>


                                            <Form.Group as={Col} lg={4} md={12} sm={12} controlId="SelectClass">
                                                <Form.Label className="ltt-field-label">Class</Form.Label>
                                                <SelectDropdown
                                                    options={this.state.getClasses}
                                                    value={this.state.Class}
                                                    placeholder="Select Class"
                                                    onSelect={(val) => this.handleInputChange({ target: { name: "Class", value: String(val) } })}
                                                />
                                                <Form.Text className="form-text text-danger" type="invalid">
                                                    {this.state.classError}
                                                </Form.Text>
                                            </Form.Group>

                                            <Form.Group as={Col} lg={4} md={12} sm={12} controlId="SelectSection">
                                                <Form.Label className="ltt-field-label">Section</Form.Label>
                                                <SelectDropdown
                                                    options={this.state.getSections}
                                                    value={this.state.Section}
                                                    placeholder="Select Section"
                                                    onSelect={(val) => this.handleInputChange({ target: { name: "Section", value: String(val) } })}
                                                />
                                                <Form.Text className="form-text text-danger" type="invalid">
                                                    {this.state.sectionError}
                                                </Form.Text>
                                            </Form.Group>
                                        </Form.Row>
                                    </Form>
                                </Col>
                            </Row>
                            <div className="row">
                                <div className="col-sm-4">
                                    {/* =====Class Periods===== */}
                                    {

                                        this.state.Section != "" && this.state.Section != "--Select Section--" ? (
                                            <>
                                                <h6>Select choice</h6>
                                                <div className="mt-2">
                                                    <SelectDropdown
                                                        options={[
                                                            { value: "1", label: "Class" },
                                                            { value: "2", label: "Exam" },
                                                            { value: "3", label: "Class & Exam" },
                                                            { value: "4", label: "Holiday" },
                                                        ]}
                                                        value={this.state.dateTimings}
                                                        placeholder="Select your choice"
                                                        showClear={false}
                                                        onSelect={(val) => this.handleInputChange({ target: { name: "dateTimings", value: String(val) } })}
                                                    />
                                                </div>
                                                <div className="form-text text-danger">{this.state.dateTimeError}</div>
                                            </>
                                        )
                                            :
                                            ("")
                                    }

                                </div>

                                {/* =====Drop Down Periods===== */}
                                <div class="col-sm-4">

                                    {
                                        dateTimings == "3" ? (
                                            <>
                                                <h6 className="mt-1">Select periods for Exams </h6>
                                                <MultiSelect
                                                    className="mt-2"
                                                    overrideStrings={{
                                                        "allItemsAreSelected": "All Periods are selected.",
                                                        "selectSomeItems": periodslabelledby
                                                    }
                                                    }
                                                    disableSearch={periodsdisablesearch}
                                                    hasSelectAll={periodsSelectAll}
                                                    options={this.state.multiSelectPeriodsList}
                                                    value={this.state.subjectValue}
                                                    onChange={(e) => this.handleMultipleSelectInputChange(e, "Periods")}
                                                    labelledBy={"Periods"}
                                                />
                                            </>
                                        ) : dateTimings == "2" ? (
                                            <>
                                                <h6 value="">Exam Name</h6>
                                                <div className="row">
                                                    <input type="text" className="col-sm-8 form-control" style={{ height: "33px" }} placeholder="Enter exam Name" name="examName" onChange={this.handleInputChange} value={this.state.Update[0]?.periodTopic} />
                                                </div>
                                                <div className="form-text text-danger">{this.state.nameError}</div>
                                            </>
                                        ) : dateTimings == "4" ? (
                                            <>
                                                <h6 value="">Holiday Name</h6>
                                                <div className="row">
                                                    <input type="text" className="col-sm-8 form-control" style={{ height: "33px" }} placeholder="Enter holiday Name" name="holidayName" onChange={this.handleInputChange} value={this.state.Update[0]?.periodTopic} />
                                                </div>
                                                <div className="form-text text-danger">{this.state.nameError}</div>
                                            </>
                                        ) : ("")
                                    }
                                </div>
                            </div>

                            {
                                this.state.Update.length > 0 ?
                                    (
                                        this.state.Update.map((val, i) => {
                                            console.log("valu", val);
                                            let resolvedSubjects = [...(this.state.classMappedSubjects || [])];
                                            let selectedSubIds = [];
                                            if (val.periodSubjectIds && val.periodSubjectIds.length > 0) {
                                                selectedSubIds = val.periodSubjectIds.map(String);
                                            } else if (val.periodSubjectId) {
                                                selectedSubIds = [String(val.periodSubjectId)];
                                            }

                                            let lecturesData = [];
                                            if (selectedSubIds.length > 0) {
                                                lecturesData = (this.state.getEmployees || []).filter((employee) => {
                                                    if (!employee.subject_ids) return false;
                                                    const empTokens = Array.isArray(employee.subject_ids)
                                                        ? employee.subject_ids.map(id => String(id).trim().toLowerCase())
                                                        : String(employee.subject_ids).split(",").map(id => id.trim().toLowerCase());

                                                    return empTokens.some(empSub => {
                                                        return selectedSubIds.some(selId => {
                                                            if (empSub === String(selId).toLowerCase()) return true;
                                                            const subObj = resolvedSubjects.find(s => String(s.id) === String(selId));
                                                            if (subObj && subObj.subject && empSub === String(subObj.subject).trim().toLowerCase()) return true;
                                                            return false;
                                                        });
                                                    });
                                                });
                                            } else {
                                                lecturesData = [];
                                            }

                                            if (resolvedSubjects.length === 0 && this.props.globals.offlineExamSubjects.length > 0 && this.state.Exam) {
                                                const examObj = this.props.globals.exams.find((item) => item.id == this.state.Exam);
                                                if (examObj && examObj.exam_subjects) {
                                                    examObj.exam_subjects.forEach((item1) => {
                                                        this.props.globals.offlineExamSubjects.forEach((item2) => {
                                                            if (item1.subject_id == item2.id) {
                                                                resolvedSubjects.push({ id: item2.id, subject: item2.subject })
                                                            }
                                                        })
                                                    })
                                                }
                                            }


                                            if (dateTimings == "1" || dateTimings == "3") {
                                                return (
                                                    <>
                                                        <Form>
                                                            <div className="row my-4">


                                                                <div className="col-sm-2">
                                                                    <h6>Period Time</h6>

                                                                    <div className="row">
                                                                        <input type="text" className="mt-2 col-sm-10 form-control m-2" style={{ height: "33px" }} value={val.period_name} disabled={true} />
                                                                    </div>
                                                                </div>

                                                                {
                                                                    val.enabled ?
                                                                        (
                                                                            <>
                                                                                <div className="col-sm-3">
                                                                                    <h6>Subject(s)</h6>
                                                                                    <div className="mt-2">
                                                                                        <CheckboxDropdown
                                                                                            options={resolvedSubjects.map(item => ({ value: String(item.id), label: item.subject }))}
                                                                                            value={val.periodSubjectIds || (val.periodSubjectId ? [String(val.periodSubjectId)] : [])}
                                                                                            onChange={(selectedValues) => this.handleMultiChange("Subject", selectedValues, i)}
                                                                                            placeholder="Select Subject(s)"
                                                                                        />
                                                                                    </div>
                                                                                    <div className="form-text text-danger fw-bold">{val.subjectError}</div>
                                                                                </div>

                                                                                <div className="col-sm-3">
                                                                                    <h6>Lecturer(s)</h6>
                                                                                    <div className="mt-2">
                                                                                        <CheckboxDropdown
                                                                                            options={lecturesData.map(item => ({ value: String(item.employee_id), label: item.employee_name }))}
                                                                                            value={val.periodLecturerIds || (val.periodLecturerId ? [String(val.periodLecturerId)] : [])}
                                                                                            onChange={(selectedValues) => this.handleMultiChange("Lecturer", selectedValues, i)}
                                                                                            placeholder={selectedSubIds.length > 0 ? "Select Lecturer(s)" : "Select Subject First"}
                                                                                        />
                                                                                    </div>
                                                                                    <div className="form-text text-danger fw-bold">{val.LecturerError}</div>
                                                                                </div>
                                                                                <div className="col-sm-3">
                                                                                    <h6>Topic</h6>
                                                                                    <div className="row">
                                                                                        <input type="text" className="mt-2 col-sm-8 form-control m-2" style={{ height: "33px" }} placeholder="Enter Topic" name="Topic" value={val.periodTopic} onChange={(e) => { this.handleChange(e, i) }} disabled={val.enabled == true ? false : true} />
                                                                                    </div>
                                                                                    <div className="form-text text-danger fw-bold">{val.topicError}</div>
                                                                                </div>

                                                                            </>
                                                                        )
                                                                        :
                                                                        (
                                                                            <>
                                                                                <div className="col-sm-3">
                                                                                    <h6>Exam Name</h6>
                                                                                    <div className="row">
                                                                                        <input type="text" className="mt-2 col-sm-8 form-control m-2" style={{ height: "33px" }} placeholder="Enter exam Name" name="examName" value={val.periodTopic} onChange={(e) => { this.handleChange(e, i) }} />
                                                                                    </div>
                                                                                </div>
                                                                            </>
                                                                        )
                                                                }

                                                            </div>
                                                        </Form>
                                                    </>
                                                )
                                            }
                                        }
                                        )
                                    )
                                    :
                                    ("")
                            }
                            {/* ===== HANDLE SUBMIT ERROR &  CLICK BUTTON ===== */}
                            <div className="d-flex justify-content-end">
                                <Row>
                                    <Col sm={12}>
                                        {
                                            this.state.Update.length > 0 && this.state.dateTimings != "" ?
                                                (
                                                    this.state.loader == 0 ? (
                                                        <button className="ltt-modal-submit" onClick={this.handleSubmit} type="submit"><i className="fas fa-check" /> Create TimeTable</button>
                                                    ) : (
                                                        <button className="ltt-modal-submit" type="submit" disabled>
                                                            <span className="spinner-border spinner-border-sm"></span> Creating...
                                                        </button>
                                                    )
                                                )
                                                :
                                                ("")
                                        }
                                    </Col>
                                </Row>
                            </div>
                            {
                                this.state.submitted == true ? (
                                    <p className="text-success d-flex justify-content-end mt-1">TimeTable Create Successfully</p>
                                ) : ("")
                            }
                        </Modal.Body>
                    </Modal>
                </div>
            </Form>
        )
    }
}

export default withRouter(withApollo(compose(
    graphql(ADD_LECTURER_PERIODS, {
        name: "addLecturerPeriods"
    }),
)(TimeTableCreationModal))
);